import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
  congratulations: {
    name: 'John',
    saleToday: '48900',
  },
  statisticsItems: [
    {
      icon: 'TrendingUpIcon',
      color: 'light-primary',
      title: '₦100,000',
      subtitle: 'Cumulative Loan Disbursed',
      customClass: 'mb-2 mb-xl-0',
    },
    {
      icon: 'UserIcon',
      color: 'light-info',
      title: '₦80,000',
      subtitle: 'Principal Outstanding',
      customClass: 'mb-2 mb-xl-0',
    },
    {
      icon: 'BoxIcon',
      color: 'light-danger',
      title: '₦15,000',
      subtitle: 'Interest Outstanding',
      customClass: 'mb-2 mb-sm-0',
    },
    {
      icon: 'TrendingDownIcon',
      color: 'light-success',
      title: '₦20,000',
      subtitle: 'Cumulative Principal Paid',
      customClass: '',
    },
    // {
    //   icon: 'TrendingUpIcon',
    //   color: 'light-success',
    //   title: '₦9,745',
    //   subtitle: 'Cumulative Interest Paid',
    //   customClass: '',
    // },
  ],
  statisticsOrder: {
    series: [
      {
        name: '2020',
        data: [45, 85, 65, 45, 65],
      },
    ],
  },
  statisticsProfit: {
    series: [
      {
        data: [0, 20, 5, 30, 15, 45],
      },
    ],
  },
  earningsChart: {
    series: [53, 16, 31],
  },
  revenue: {
    years: ['2020', '2019', '2018'],
    price: '25852',
    budget: '56,800',
    revenueReport: {
      series: [
        {
          name: 'Income',
          data: [95, 177, 284, 256, 105, 63, 168, 218, 72],
        },
        {
          name: 'Expense',
          data: [-145, -80, -60, -180, -100, -60, -85, -75, -100],
        },
      ],
    },
    budgetChart: {
      series: [
        {
          data: [61, 48, 69, 52, 60, 40, 79, 60, 59, 43, 62],
        },
        {
          data: [20, 10, 30, 15, 23, 0, 25, 15, 20, 5, 27],
        },
      ],
    },
  },
  companyTable: [
    {
      avatarImg: require('@/assets/images/icons/toolbox.svg'),
      title: 'Olufisayo Oludare',
      subtitle: 'fisayo@gmail.com',
      avatarIcon: 'MonitorIcon',
      avatarColor: 'light-primary',
      avatarTitle: 'Head Office',
      viewTitle: 'Credit',
      viewsub: 'in 24 hours',
      revenue: '891.2',
      sales: '68',
      loss: true,
    },
    {
      avatarImg: require('@/assets/images/icons/parachute.svg'),
      title: 'Ikenna Agugua',
      subtitle: 'ikenna@@gmail.com',
      avatarIcon: 'CoffeeIcon',
      avatarColor: 'light-success',
      avatarTitle: 'Ikeja',
      viewTitle: 'Teller',
      viewsub: 'in 2 days',
      revenue: '668.51',
      sales: '97',
      loss: false,
    },
    {
      avatarImg: require('@/assets/images/icons/brush.svg'),
      title: 'Sarah Grace',
      subtitle: 'sarah@gmail.com',
      avatarIcon: 'WatchIcon',
      avatarColor: 'light-warning',
      avatarTitle: 'Lekki',
      viewTitle: 'Operations',
      viewsub: 'in 5 days',
      revenue: '522.29',
      sales: '62',
      loss: false,
    },
    {
      avatarImg: require('@/assets/images/icons/star.svg'),
      title: 'Samuel Ukpong',
      subtitle: 'samuel@gmail.com',
      avatarIcon: 'MonitorIcon',
      avatarColor: 'light-primary',
      avatarTitle: 'Isolo',
      viewTitle: 'Finance',
      viewsub: 'in 24 hours',
      revenue: '291.01',
      sales: '88',
      loss: false,
    },
    {
      avatarImg: require('@/assets/images/icons/book.svg'),
      title: 'Emmanuel Odeniya',
      subtitle: 'emmanuel@gmail.com',
      avatarIcon: 'CoffeeIcon',
      avatarColor: 'light-success',
      avatarTitle: 'V.I',
      viewTitle: 'Admin',
      viewsub: 'in 1 week',
      revenue: '783.93',
      sales: '16',
      loss: true,
    },
    {
      avatarImg: require('@/assets/images/icons/rocket.svg'),
      title: 'Kmart',
      subtitle: 'kmart@gmail.com',
      avatarIcon: 'WatchIcon',
      avatarColor: 'light-warning',
      avatarTitle: 'Fashion',
      viewTitle: 'Teller',
      viewsub: 'in 1 month',
      revenue: '780.05',
      sales: '78',
      loss: false,
    },
    {
      avatarImg: require('@/assets/images/icons/speaker.svg'),
      title: 'Payers',
      subtitle: 'payers@gmail.com',
      avatarIcon: 'WatchIcon',
      avatarColor: 'light-warning',
      avatarTitle: 'Fashion',
      viewTitle: '12.9k',
      viewsub: 'in 12 hours',
      revenue: '531.49',
      sales: '42',
      loss: false,
    },
  ],
  meetup: {
    mediaData: [
      { avatar: 'CalendarIcon', title: 'Sat, May 25, 2020', subtitle: '10:AM to 6:PM' },
      { avatar: 'MapPinIcon', title: 'Central Park', subtitle: 'Manhattan, New york City' },
    ],
    avatars: [
      { avatar: '', fullName: 'Billy Hopkins' },
      { avatar: '', fullName: 'Amy Carson' },
      { avatar: '', fullName: 'Brandon Miles' },
      { avatar: '', fullName: 'Daisy Weber' },
      { avatar: '', fullName: 'Jenny Looper' },
    ],
  },
  goalOverview: {
    completed: '1,360',
    inProgress: '500',
    series: [83],
  },
  transactionData: [
    {
      mode: 'Performing',
      types: '50%',
      avatar: 'PocketIcon',
      avatarVariant: 'light-primary',
      payment: '₦40,000',
      deduction: true,
    },
    {
      mode: 'Pass & Watch',
      types: '12.5%',
      avatar: 'CheckIcon',
      avatarVariant: 'light-success',
      payment: '₦10,000',
      deduction: false,
    },
    {
      mode: 'Sub-standard',
      types: '25%',
      avatar: 'TrendingUpIcon',
      avatarVariant: 'light-danger',
      payment: '₦20,000',
      deduction: false,
    },
    {
      mode: 'Doubtful',
      types: '18.75%',
      avatar: 'CreditCardIcon',
      avatarVariant: 'light-warning',
      payment: '₦15,000',
      deduction: true,
    },
    {
      mode: 'Lost',
      types: '6.25%',
      avatar: 'TrendingUpIcon',
      avatarVariant: 'light-info',
      payment: '₦5,000',
      deduction: false,
    },
  ],
}
/* eslint-disable global-require */
mock.onGet('/ecommerce/data').reply(() => [200, data])
